<template>
	<div class="webContent flex messagePage">
		<div class="remind">
			<div class="model df hao">
				<div class="modelLi flex" :class="{ cur: chooseModel=='checkResult' }" @click="tabModel('checkResult')">审核结果<i v-if="count.checkResult>0">{{count.checkResult>10?'10+':count.checkResult}}</i></div>
				<div class="modelLi flex" :class="{ cur: chooseModel=='newAnswer' }" @click="tabModel('newAnswer')">新的回答<i v-if="count.ask>0">{{count.ask>10?'10+':count.ask}}</i></div>
				<div class="modelLi flex" :class="{ cur: chooseModel=='followLike' }" @click="tabModel('followLike')">关注和点赞<i v-if="count.nav>0">{{count.nav>10?'10+':count.nav}}</i></div>
			</div>
			<!-- 审核结果 -->
			<div class="list" v-show="chooseModel=='checkResult'" @scroll="listenScroll_checkResult">
				<div class="li" v-for="(v,i) in checkResultList" :key="i" 
					@click="toDetail('checkResult',v.question,v.id)" v-if="v.question">
					<div class="cap" v-if="v.types==1">{{returnRetDate(v.createTime)}}<i>|</i>问题被通过</div>
					<div class="cap" v-else-if="v.types==2">{{returnRetDate(v.createTime)}}<i>|</i>问题被驳回<br>原因是<div v-html="v.question.failReason" style="display: inline;">{{v.question.failReason}}</div></div>
					<div class="item df hao">
						<div class="lt flex">
							<div class="title ov-d">{{v.question && v.question.title}}</div>
							<div class="tool df">
								<div class="flex">{{dateTime(v.question && v.question.createTime)}} · {{(v.question && v.question.answerTotal>0) ? v.question.answerTotal+'人回答':'暂无回答'}} · {{(v.question && v.question.attentionTotal>0) ? v.question.attentionTotal+'人关注':'暂无关注'}}</div>
							</div>
						</div>
						<div class="state" v-if="v.types==2">审核驳回</div>
						<div class="state state2" v-if="v.types==1">审核通过</div>
					</div>
				</div>
			</div>
			<!-- 新的回答 -->
			<div class="content" v-show="chooseModel=='newAnswer'">
				<div class="nav df hao">
					<div class="navLi flex" :class="{ cur: chooseNav=='proposeAsk' }" @click="tabNav('proposeAsk')">我提出的问题<i v-if="count.proposeAsk>0">{{count.proposeAsk>10?'10+':count.proposeAsk}}</i></div>
					<div class="navLi flex" :class="{ cur: chooseNav=='followAsk' }" @click="tabNav('followAsk')"><i v-if="count.followAsk>0">{{count.followAsk>10?'10+':count.followAsk}}</i>我关注的问题</div>
				</div>
				<!-- 我提出的问题 -->
				<div class="list2" v-show="chooseNav=='proposeAsk'" @scroll="listenScroll_proposeAsk">
					<div class="li2" v-for="(v,i) in proposeAskList" :key="i"
						@click="toDetail('proposeAsk',v.question,v.id)">
						<div class="cap"><em>{{v.answer && v.answer.creatorName}}（{{v.answer && v.answer.creatorMapperNumber}}）</em><i>|</i>{{returnRetDate(v.answer&&v.answer.createTime)}} 回答了问题</div>
						<div class="item">
							<div class="title"><i class="top" v-if="v.question && v.question.top==1"></i><i class="prize" v-if="v.question && v.question.refining==1"></i>{{v.question &&v.question.title}}</div>
							<div class="txt ov-4d" v-html="v.answer && v.answer.content">{{v.answer && v.answer.content}}</div>
							<div class="end df hao">
								<div class="like" :class="{ has: v.question && v.question.approval!=0 }" @click.stop.prevent="likeItem(v.question.id,v.question.approval,v.question,1)">{{v.question&&v.question.approvalTotal}}</div>
								<div class="collect" :class="{ has: v.question && v.question.collection!=0 }" @click.stop.prevent="collectItem(v.question.id,v.question.collection,v.question,1)">{{v.question&&v.question.collectionTotal}}</div>
								<div class="flex"></div>
								<div class="user">{{v.question && v.question.creatorName||''}}</div>
								<div class="date">{{dateTime(v.question && v.question.createTime)}}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 我关注的问题 -->
				<div class="list2" v-show="chooseNav=='followAsk'" @scroll="listenScroll_followAsk">
					<div class="li2" v-for="(v,i) in followAskList" :key="i"
						@click="toDetail('followAsk',v.question,v.id)">
						<div class="cap"><em>{{v.answer && v.answer.creatorName}}（{{v.answer && v.answer.creatorMapperNumber}}）</em><i>|</i>{{returnRetDate(v.answer&&v.answer.createTime)}} 回答了问题</div>
						<div class="item">
							<div class="title"><i class="top" v-if="v.question && v.question.top==1"></i><i class="prize" v-if="v.question && v.question.refining==1"></i> {{v.question &&v.question.title}}</div>
							<div class="txt ov-4d" v-html="v.answer && v.answer.content">{{v.answer && v.answer.content}}</div>
							<div class="end df hao">
								<div class="like" :class="{ has: v.question && v.question.approval!=0 }" @click.stop.prevent="likeItem(v.question.id,v.question.approval,v.question,2)">{{v.question && v.question.approvalTotal}}</div>
								<div class="collect" :class="{ has: v.question&&v.question.collection!=0 }" @click.stop.prevent="collectItem(v.question.id,v.question.collection,v.question,2)">{{v.question && v.question.collectionTotal}}</div>
								<div class="flex"></div>
								<div class="user">{{v.question && v.question.creatorName||''}}</div>
								<div class="date">{{dateTime(v.question&&v.question.createTime)}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 关注和点赞 -->
			<div class="content" v-show="chooseModel=='followLike'">
				<div class="nav df hao nav2 nav3" v-if="$h5Power=='instructor'||$h5Power=='teacher'">
					<div class="navLi flex" :class="{ cur: chooseNav2=='followNav' }" @click="tabNav2('followNav')">关注<i v-if="count.followNav>0">{{count.followNav>10?'10+':count.followNav}}</i></div>
					<div class="navLi flex" :class="{ cur: chooseNav2=='collectNav' }" @click="tabNav2('collectNav')">收藏<i v-if="count.collectNav>0">{{count.collectNav>10?'10+':count.collectNav}}</i></div>
					<div class="navLi flex" :class="{ cur: chooseNav2=='likeNav' }" @click="tabNav2('likeNav')"><i v-if="count.likeNav>0">{{count.likeNav>10?'10+':count.likeNav}}</i>点赞</div>
				</div>
				<div class="nav df hao nav2" v-else>
					<div class="navLi flex" :class="{ cur: chooseNav2=='followNav' }" @click="tabNav2('followNav')">关注<i v-if="count.followNav>0">{{count.followNav>10?'10+':count.followNav}}</i></div>
					<div class="navLi flex" :class="{ cur: chooseNav2=='likeNav' }" @click="tabNav2('likeNav')"><i v-if="count.likeNav>0">{{count.likeNav>10?'10+':count.likeNav}}</i>点赞</div>
				</div>
				<!-- 关注 -->
				<div class="list3" v-show="chooseNav2=='followNav'" @scroll="listenScroll_followNav">
					<div class="li3" v-for="(v,i) in followNavList" :key="i">
						<div class="cap" v-if="v.types==5" @click="toFollowUser(v.creatorId)"><em>{{v.creatorName}}（{{v.creatorMapperNumber}}）</em><i>|</i>{{returnRetDate(v.createTime)}} 关注了你提出的问题</div>
						<div class="cap" v-else-if="v.types==7" @click="toFollowUser(v.creatorId)"><em>{{v.creatorName}}（{{v.creatorMapperNumber}}）</em><i>|</i>{{returnRetDate(v.createTime)}} 关注了你</div>
						<div class="item df hao" v-if="v.types==5" @click="toDetail('followNav',v.question,v.id)">
							<div class="lt flex">
								<div class="title ov-d">{{v.question &&v.question.title}}</div>
								<div class="tool df">
									<div class="flex">{{dateTime(v.question && v.question.createTime)}} · {{(v.question && v.question.answerTotal>0) ? v.question.answerTotal+'人回答':'暂无回答'}} · {{(v.question && v.question.attentionTotal>0) ? v.question.attentionTotal+'人关注':'暂无关注'}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 收藏 -->
				<div class="list3" v-show="chooseNav2=='collectNav'" @scroll="listenScroll_collectNav">
					<div class="li2" v-for="(v,i) in collectNavList" :key="i"
						@click="toDetail('collectNav',v.question,v.id)">
						<div class="cap"><em>{{v.creatorName}}（{{v.creatorMapperNumber}}）</em><i>|</i>{{returnRetDate(v.createTime)}} 收藏了你的回答</div>
						<div class="item">
							<div class="title"><i class="top" v-if="v.question && v.question.top==1"></i><i class="prize" v-if="v.question && v.question.refining==1"></i>{{v.question &&v.question.title}}</div>
							<div class="txt ov-4d" v-html="v.question.content">{{v.question.content}}</div>
							<div class="end df hao">
								<div class="like" :class="{ has: v.question&&v.question.approval!=0 }" @click.stop.prevent="likeItem(v.question.id,v.question.approval,v.question,3)">{{v.question&&v.question.approvalTotal}}</div>
								<div class="collect" :class="{ has: v.question&&v.question.collection!=0 }" @click.stop.prevent="collectItem(v.question.id,v.question.collection,v.question,3)">{{v.question&&v.question.collectionTotal}}</div>
								<div class="flex"></div>
								<div class="user">{{v.question.creatorName||''}}</div>
								<div class="date">{{dateTime(v.question&&v.question.createTime)}}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 点赞 -->
				<div class="list3" v-show="chooseNav2=='likeNav'" @scroll="listenScroll_likeNav">
					<div class="li3" v-for="(v,i) in likeNavList" :key="i"
						@click="toDetail('likeNav',v.question,v.id)">
						<div class="cap" v-if="v.types==6"><em>{{v.creatorName}}（{{v.creatorMapperNumber}}）</em><i>|</i>{{returnRetDate(v.createTime)}} 点赞了你提出的问题</div>
						<div class="cap" v-else-if="v.types==9"><em>{{v.creatorName}}（{{v.creatorMapperNumber}}）</em><i>|</i>{{returnRetDate(v.createTime)}} 点赞了你的回答</div>
						<div class="item df hao">
							<div class="lt flex">
								<div class="title ov-d">{{v.question &&v.question.title}}</div>
								<div class="tool df">
									<div class="flex">{{dateTime(v.question&&v.question.createTime)}} · {{(v.question && v.question.answerTotal>0) ? v.question.answerTotal+'人回答':'暂无回答'}} · {{(v.question && v.question.attentionTotal>0) ? v.question.attentionTotal+'人关注':'暂无关注'}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 收藏夹 -->
		<div class="collectBase" v-if="collectBase.has">
			<div class="collectBase-box">
				<div class="collectBase-top">
					<div class="collectBase-close" @click="closeCollectBase"></div>
					<span>已选择{{collectBase.choose.length}}个收藏夹</span>
					<div class="collectBase-add" @click="showCollectAddBase">新建收藏夹</div>
				</div>
				<div class="collectBase-list">
					<div class="collectBase-li df cf wao" :class="{ cur: collectBase.choose.indexOf(i)>=0 }" 
						v-for="(v,i) in collectBase.list" :key="i" 
						@click="chooseCollectBase(i)">
						<div class="collectBase-title">{{v.name}}</div>
						<div class="collectBase-answer">{{v.answerTotal}}个回答</div>
					</div>
				</div>
				<div class="collectBase-btn" @click="resCollectBase">确认</div>
			</div>
		</div>

		<!-- 添加收藏夹 -->
		<div class="collectAddBase df wao hao" v-if="collectAddBase.has">
			<div class="collectAddBase-box">
				<div class="collectAddBase-input df hao">
					<input type="text" puc class="flex" placeholder="输入收藏夹标题" v-model="collectAddBase.val" @input="checkInput" />
					<i>{{13-collectAddBase.val.length}}</i>
				</div>
				<div class="collectAddBase-end df war hao">
					<div class="collectAddBase-btn" @click="resCollectAddBase">确认</div>
					<div class="collectAddBase-btn" @click="closeCollectAddBase">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// /events/listPageByUser 接口 types [1 提出的问题审核通过] [2 提出的问题审核驳回] [3 提出的问题被回答] [4 关注的问题被回答] [5 提出的问题被关注] [6 提出的问题被点赞] [7 被别人关注] [8 回答被收藏] [9 回答被点赞]
	
	import h5PublicApi from '../../../script/public.js'

	let collect_nav = '';
	let collect_obj = null;

	export default {
		name: 'message_index_page',
		data () {
			return {
				chooseModel: h5PublicApi.tabNavTed('get','messageIndexModel','checkResult'),
				chooseNav: h5PublicApi.tabNavTed('get','messageIndexNav','proposeAsk'),
				chooseNav2: h5PublicApi.tabNavTed('get','messageIndexNav2','followNav'),
				count: {
					checkResult: 0, // 审核结果统计
					ask: 0, // 我提出的问题统计 + 我关注的问题统计
					nav: 0, // 关注提醒统计 + 收藏提醒统计 + 点赞提醒统计
					proposeAsk: 0, // 我提出的问题统计
					followAsk: 0, // 我关注的问题统计
					followNav: 0, // 关注提醒统计
					collectNav: 0, // 收藏提醒统计
					likeNav: 0, // 点赞提醒统计
				},
				pagenum_checkResult: 1,
				pagesize_checkResult: 10,
				state_checkResult: false,
				checkResultList: [],
				pagenum_proposeAsk: 1,
				pagesize_proposeAsk: 10,
				state_proposeAsk: false,
				proposeAskList: [],
				pagenum_followAsk: 1,
				pagesize_followAsk: 10,
				state_followAsk: false,
				followAskList: [],
				pagenum_followNav: 1,
				pagesize_followNav: 10,
				state_followNav: false,
				followNavList: [],
				pagenum_collectNav: 1,
				pagesize_collectNav: 10,
				state_collectNav: false,
				collectNavList: [],
				pagenum_likeNav: 1,
				pagesize_likeNav: 10,
				state_likeNav: false,
				likeNavList: [],
				collectBase: {
					id: '',
					index: null,
					has: false,
					choose: [],
					list: [],
				},
				collectAddBase: {
					has: false,
					val: '',
				},
			}
		},
		mounted(){
			// 查询当前登录用户的提醒信息统计
			this.getCount()

			// 获取审核结果
			this.getList_checkResult();

			// 获取我提出的问题
			this.getList_proposeAsk();

			// 获取我关注的问题
			this.getList_followAsk();

			// 获取关注提醒
			this.getList_followNav();

			// 获取收藏提醒
			this.getList_collectNav();

			// 获取点赞提醒
			this.getList_likeNav();

			h5PublicApi.tabNavTed('set','homeType','');
			h5PublicApi.tabNavTed('set','meIndexModel','');
			h5PublicApi.tabNavTed('set','meIndexNav','');
			h5PublicApi.tabNavTed('set','meIndexNav2','');
			h5PublicApi.tabNavTed('set','adminIndexModel','');
		},
		methods: {
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			returnRetDate(timestamp){
				if(!timestamp){ return ''; }
				var nowDateStamp = new Date().getTime();
				var k = nowDateStamp-timestamp;
				if(k<60*60*1000){ // 1小时内
					var t = parseInt(k/(60*1000));
					return (t<5?'刚刚':t+'分钟前');
				}else if(k<24*60*60*1000){ // 24小时内
					return parseInt(k/(60*60*1000))+'小时前';
				}

				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			tabModel(model){
				this.chooseModel = model;
				h5PublicApi.tabNavTed('set','messageIndexModel',model)

				if(model=='newAnswer'){
					// 设置该提醒为已查看
					this.h5Ajax('post','$/events/modifyStatusByUid',{
						types: (this.chooseNav=='proposeAsk'?'1,2,3':'4'), // [1 提出的问题审核通过] [2 提出的问题审核驳回] [3 提出的问题被回答] [4 关注的问题被回答] [5 提出的问题被关注] [6 提出的问题被点赞] [7 被别人关注] [8 回答被收藏] [9 回答被点赞]
					}).then(r=>{
						this.getCount()
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(model=='followLike'){
					// 设置该提醒为已查看
					this.h5Ajax('post','$/events/modifyStatusByUid',{
						types: (this.chooseNav2=='followNav'?'5,7':(this.chooseNav2=='collectNav'?'8':'6,9')), // [1 提出的问题审核通过] [2 提出的问题审核驳回] [3 提出的问题被回答] [4 关注的问题被回答] [5 提出的问题被关注] [6 提出的问题被点赞] [7 被别人关注] [8 回答被收藏] [9 回答被点赞]
					}).then(r=>{
						this.getCount()
					}).catch(err => {
						console.error('err:' + err)
					})
				}
			},
			tabNav(nav){
				this.chooseNav = nav;
				h5PublicApi.tabNavTed('set','messageIndexNav',nav)

				// 设置该提醒为已查看
				this.h5Ajax('post','$/events/modifyStatusByUid',{
					types: (nav=='proposeAsk'?'1,2,3':'4'), // [1 提出的问题审核通过] [2 提出的问题审核驳回] [3 提出的问题被回答] [4 关注的问题被回答] [5 提出的问题被关注] [6 提出的问题被点赞] [7 被别人关注] [8 回答被收藏] [9 回答被点赞]
				}).then(r=>{
					this.getCount()
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			tabNav2(nav){
				this.chooseNav2 = nav;
				h5PublicApi.tabNavTed('set','messageIndexNav2',nav)

				// 设置该提醒为已查看
				this.h5Ajax('post','$/events/modifyStatusByUid',{
					types: (nav=='followNav'?'5,7':(nav=='collectNav'?'8':'6,9')), // [1 提出的问题审核通过] [2 提出的问题审核驳回] [3 提出的问题被回答] [4 关注的问题被回答] [5 提出的问题被关注] [6 提出的问题被点赞] [7 被别人关注] [8 回答被收藏] [9 回答被点赞]
				}).then(r=>{
					this.getCount()
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			getCount(){ // 查询当前登录用户的提醒信息统计
				this.h5Ajax('get','$/events/userCount',{}).then(r=>{
					var count = {
						checkResult: 0, // 审核结果统计
						ask: 0, // 我提出的问题统计 + 我关注的问题统计
						nav: 0, // 关注提醒统计 + 收藏提醒统计 + 点赞提醒统计
						proposeAsk: 0, // 我提出的问题统计
						followAsk: 0, // 我关注的问题统计
						followNav: 0, // 关注提醒统计
						collectNav: 0, // 收藏提醒统计
						likeNav: 0, // 点赞提醒统计
					};

					(r||'').forEach((v,i)=>{
						if([1,2].indexOf(v.types)>=0){ // 提出的问题审核通过/提出的问题审核驳回
							count.checkResult += Number(v.total); // 审核结果统计
						}else if([3].indexOf(v.types)>=0){ // 提出的问题被回答
							count.proposeAsk += Number(v.total); // 我提出的问题统计
							count.ask += Number(v.total); // 我提出的问题统计 + 我关注的问题统计
						}else if([4].indexOf(v.types)>=0){ // 关注的问题被回答
							count.followAsk += Number(v.total); // 我关注的问题统计
							count.ask += Number(v.total); // 我提出的问题统计 + 我关注的问题统计
						}else if([5,7].indexOf(v.types)>=0){ // 提出的问题被关注/被别人关注
							count.followNav += Number(v.total); // 关注提醒统计
							count.nav += Number(v.total); // 关注提醒统计 + 收藏提醒统计 + 点赞提醒统计
						}else if((this.$h5Power=='instructor'||this.$h5Power=='teacher') && [8].indexOf(v.types)>=0){ // 回答被收藏
							count.collectNav += Number(v.total); // 收藏提醒统计
							count.nav += Number(v.total); // 关注提醒统计 + 收藏提醒统计 + 点赞提醒统计
						}else if([6,9].indexOf(v.types)>=0){ // 提出的问题被点赞/回答被点赞
							count.likeNav += Number(v.total); // 点赞提醒统计
							count.nav += Number(v.total); // 关注提醒统计 + 收藏提醒统计 + 点赞提醒统计
						}
					})
		
					this.count = count;
				}).catch(err => {
					console.error('err:' + err)
				})

				window.h5GetMessageCount && window.h5GetMessageCount();
			},
			listenScroll_checkResult(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_checkResult();
				}
			},
			addMoreData_checkResult() { //加载更多
				if(this.state_checkResult){
					return false;
				}
				this.pagenum_checkResult ++;
				this.getList_checkResult();
			},
			getList_checkResult(){
				this.state_checkResult = true;

				this.h5Ajax('get','$/events/listPageByUser',{
					page: this.pagenum_checkResult,
					size: this.pagesize_checkResult,
					types: '1,2',
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.checkResultList.push(d);
						}
						this.state_checkResult = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_proposeAsk(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_proposeAsk();
				}
			},
			addMoreData_proposeAsk() { //加载更多
				if(this.state_proposeAsk){
					return false;
				}
				this.pagenum_proposeAsk ++;
				this.getList_proposeAsk();
			},
			getList_proposeAsk(){
				this.state_proposeAsk = true;

				this.h5Ajax('get','$/events/listPageByUser',{
					page: this.pagenum_proposeAsk,
					size: this.pagesize_proposeAsk,
					types: '3',
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.proposeAskList.push(d);
						}
						this.state_proposeAsk = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_followAsk(e) {  //监听滚动
		
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_followAsk();
				}
			},
			addMoreData_followAsk() { //加载更多
				if(this.state_followAsk){
					return false;
				}
				this.pagenum_followAsk ++;
				this.getList_followAsk();
			},
			getList_followAsk(){
				this.state_followAsk = true;

				this.h5Ajax('get','$/events/listPageByUser',{
					page: this.pagenum_followAsk,
					size: this.pagesize_followAsk,
					types: '4',
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.followAskList.push(d);
						}
						this.state_followAsk = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_followNav(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_followNav();
				}
			},
			addMoreData_followNav() { //加载更多
				if(this.state_followNav){
					return false;
				}
				this.pagenum_followNav ++;
				this.getList_followNav();
			},
			getList_followNav(){
				this.state_followNav = true;

				this.h5Ajax('get','$/events/listPageByUser',{
					page: this.pagenum_followNav,
					size: this.pagesize_followNav,
					// types: (this.$h5Power=='instructor'||this.$h5Power=='teacher'?'5,7':'7'),
					types: '5,7',
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.followNavList.push(d);
						}
						this.state_followNav = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_collectNav(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_collectNav();
				}
			},
			addMoreData_collectNav() { //加载更多
				if(this.state_collectNav){
					return false;
				}
				this.pagenum_collectNav ++;
				this.getList_collectNav();
			},
			getList_collectNav(){
				this.state_collectNav = true;

				this.h5Ajax('get','$/events/listPageByUser',{
					page: this.pagenum_collectNav,
					size: this.pagesize_collectNav,
					types: '8',
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.collectNavList.push(d);
						}
						this.state_collectNav = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			listenScroll_likeNav(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData_likeNav();
				}
			},
			addMoreData_likeNav() { //加载更多
				if(this.state_likeNav){
					return false;
				}
				this.pagenum_likeNav ++;
				this.getList_likeNav();
			},
			getList_likeNav(){
				this.state_likeNav = true;

				this.h5Ajax('get','$/events/listPageByUser',{
					page: this.pagenum_likeNav,
					size: this.pagesize_likeNav,
					types: '6,9',
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.likeNavList.push(d);
						}
						this.state_likeNav = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			collectItem(id,wid,item,nav){
				collect_nav = nav;
				collect_obj = item;
				if(wid>0){
					this.h5Ajax('post','$/collections/cancel',{
						id: wid,
					}).then(r=>{
						if(nav==2||nav==3){ // 获取我提出的问题
							this.pagenum_proposeAsk = 1;
							this.state_proposeAsk = false;
							this.proposeAskList = [];
							this.getList_proposeAsk();
						}
						if(nav==1||nav==3){ // 获取我关注的问题
							this.pagenum_followAsk = 1;
							this.state_followAsk = false;
							this.followAskList = [];
							this.getList_followAsk();
						}
						if(nav==1||nav==2){ // 获取收藏提醒
							this.pagenum_collectNav = 1;
							this.state_collectNav = false;
							this.collectNavList = [];
							this.getList_collectNav();
						}

						item.collection = 0;
						item.collectionTotal --;
					}).catch(err => {
						console.error('err:' + err)
					})
				}else{
					this.collectBase = {
						id: id,
						index: 1,
						has: true,
						choose: [],
						list: [],
					};

					this.getCollectList();
				}
			},
			getCollectList(){
				this.h5Ajax('get','$/favorites/listByUid',{
					personal: 0,
				}).then(r=>{
					this.collectBase.choose = [];
					this.collectBase.list = r;
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			closeCollectBase(){
				this.collectBase.has = false;
			},
			resCollectBase(){
				if(this.collectBase.choose.length==0){
					alert('请选择收藏夹');
					return;
				}

				var fid = this.collectBase.list[this.collectBase.choose].id;

				this.h5Ajax('post','$/collections/add',{
					collectionId: this.collectBase.id,
					favoriteId: fid,
					types: 1,
				}).then(r=>{
					this.collectBase.has = false;

					if(collect_nav==2||collect_nav==3){ // 获取我提出的问题
						this.pagenum_proposeAsk = 1;
						this.state_proposeAsk = false;
						this.proposeAskList = [];
						this.getList_proposeAsk();
					}
					if(collect_nav==1||collect_nav==3){ // 获取我关注的问题
						this.pagenum_followAsk = 1;
						this.state_followAsk = false;
						this.followAskList = [];
						this.getList_followAsk();
					}
					if(collect_nav==1||collect_nav==2){ // 获取收藏提醒
						this.pagenum_collectNav = 1;
						this.state_collectNav = false;
						this.collectNavList = [];
						this.getList_collectNav();
					}
					
					collect_obj.collection = r.id;
					collect_obj.collectionTotal ++;
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			showCollectAddBase(){
				this.collectAddBase = {
					has: true,
					val: '',
				}
			},
			closeCollectAddBase(){
				this.collectAddBase.has = false;
			},
			resCollectAddBase(){
				this.h5Ajax('post','$/favorites/add',{
					name: this.collectAddBase.val,
					personal: 0,
				}).then(r=>{
					this.collectAddBase.has = false;
					this.getCollectList();
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			chooseCollectBase(index){
				// if(this.collectBase.choose.indexOf(index)>=0){
				// 	this.collectBase.choose.splice(this.collectBase.choose.indexOf(index),1);
				// }else{
				// 	this.collectBase.choose.push(index);
				// }
				if(this.collectBase.choose[0]==index){
					this.collectBase.choose = [];
				}else{
					this.collectBase.choose = [index];
				}
			},
			checkInput(){
				if(this.collectAddBase.val.length>13){
					this.collectAddBase.val = this.collectAddBase.val.substring(0,13);
				}
			},
			likeItem(id,wid,item,nav){
				if(wid>0){
					this.h5Ajax('post','$/approvals/cancel',{
						id: wid,
					}).then(r=>{
						if(nav==2||nav==3){ // 获取我提出的问题
							this.pagenum_proposeAsk = 1;
							this.state_proposeAsk = false;
							this.proposeAskList = [];
							this.getList_proposeAsk();
						}
						if(nav==1||nav==3){ // 获取我关注的问题
							this.pagenum_followAsk = 1;
							this.state_followAsk = false;
							this.followAskList = [];
							this.getList_followAsk();
						}
						if(nav==1||nav==2){ // 获取收藏提醒
							this.pagenum_collectNav = 1;
							this.state_collectNav = false;
							this.collectNavList = [];
							this.getList_collectNav();
						}

						item.approval = 0;
						item.approvalTotal --;
					})
				}else{
					this.h5Ajax('post','$/approvals/add',{
						approvalId: id,
						types: 1,
					}).then(r=>{
						if(nav==2||nav==3){ // 获取我提出的问题
							this.pagenum_proposeAsk = 1;
							this.state_proposeAsk = false;
							this.proposeAskList = [];
							this.getList_proposeAsk();
						}
						if(nav==1||nav==3){ // 获取我关注的问题
							this.pagenum_followAsk = 1;
							this.state_followAsk = false;
							this.followAskList = [];
							this.getList_followAsk();
						}
						if(nav==1||nav==2){ // 获取收藏提醒
							this.pagenum_collectNav = 1;
							this.state_collectNav = false;
							this.collectNavList = [];
							this.getList_collectNav();
						}

						item.approval = r.id;
						item.approvalTotal ++;
					})
				}
			},
			toDetail(model,data,mid){
				if(data && data.id){
					// 设置该提醒为已查看
					this.h5Ajax('post','$/events/modifyStatus/'+mid,{}).then(r=>{
						// if(data && data.id){
							this.$router.replace({ path: '/model/detail', query: { id: data.id } });
						// }else{
						// 	// 查询当前登录用户的提醒信息统计
						// 	this.getCount()

						// 	if(model=='checkResult'){ // 获取审核结果
						// 		this.pagenum_checkResult = 1;
						// 		this.state_checkResult = false;
						// 		this.checkResultList = [];
						// 		this.getList_checkResult();
						// 	}else if(model=='proposeAsk'){ // 获取我提出的问题
						// 		this.pagenum_proposeAsk = 1;
						// 		this.state_proposeAsk = false;
						// 		this.proposeAskList = [];
						// 		this.getList_proposeAsk();
						// 	}else if(model=='followAsk'){ // 获取我关注的问题
						// 		this.pagenum_followAsk = 1;
						// 		this.state_followAsk = false;
						// 		this.followAskList = [];
						// 		this.getList_followAsk();
						// 	}else if(model=='followNav'){ // 获取关注提醒
						// 		this.pagenum_followNav = 1;
						// 		this.state_followNav = false;
						// 		this.followNavList = [];
						// 		this.getList_followNav();
						// 	}else if(model=='collectNav'){ // 获取收藏提醒
						// 		this.pagenum_collectNav = 1;
						// 		this.state_collectNav = false;
						// 		this.collectNavList = [];
						// 		this.getList_collectNav();
						// 	}else if(model=='likeNav'){ // 获取点赞提醒
						// 		this.pagenum_likeNav = 1;
						// 		this.state_likeNav = false;
						// 		this.likeNavList = [];
						// 		this.getList_likeNav();
						// 	}
						// }
					}).catch(err => {
						console.error('err:' + err)
					})
				}
			},
			toFollowUser(uid){
				this.$router.replace({ path: '/me/user', query: { id: uid } });
			}
		},
	}
</script>

<style scoped>
	@import './index';
</style>

<style type="text/css">
	.messagePage .li .cap textarea{
		display: none !important;
	}
</style>


// WEBPACK FOOTER //
// src/app/pages/message/index/index.vue